import { PhoneOutlined } from '@mui/icons-material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { matchPath, useLocation } from 'react-router';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { leftNavigationBarTranslation } from '@/assets/locales/menu/leftNavigationBar.translation.pl.ts';
import { LeftBarNavigationBar } from '@/components/ui/leftBarNavigation/components/LeftBarNavigationBar.comp.tsx';
import { LeftBarNavigationTabsStyles } from '@/components/ui/leftBarNavigation/leftBarNavigation.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';
import { AnnouncementAnchorKey } from '@/contexts/announcements/announcements.definitions.ts';
import { useAppConfig } from '@/contexts/appConfig/AppConfig.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useVisibilityAwareInterval } from '@/utils/useVisibilityAwareInterval.util.ts';

const currentViews = Object.keys(leftNavigationBarTranslation) as RouteEnum[];

export const LeftBarNavigation: React.FC = () => {
  const { isCommissionEnabled, isEmailEnabled, isEmergencyContactsEnabled } = useAppConfig();
  const location = useLocation();
  // const { chatConversationsStatus } = useReadChatConversationsStatus();
  // const unreadCount = chatConversationsStatus.reduce((acc, it) => acc + it.unreadCount, 0);
  const queryClient = useQueryClient();
  const value =
    currentViews.find(
      route => !route.includes(':') && matchPath({ end: false, path: route }, location.pathname),
    ) ?? RouteEnum.DASHBOARD;

  useVisibilityAwareInterval(() => {
    void queryClient.refetchQueries({ queryKey: [QueryKeyEnum.CHATS.ALL_STATUS] });
  }, 20 * 1000);

  return (
    <Tabs
      orientation="vertical"
      sx={LeftBarNavigationTabsStyles}
      value={value}
      variant="scrollable"
    >
      {isEmergencyContactsEnabled && (
        <LeftBarNavigationBar
          Icon={PhoneOutlined}
          isRed
          selectedValue={value}
          value={RouteEnum.EMERGENCY_CONTACTS}
        />
      )}
      <LeftBarNavigationBar Icon={HomeOutlinedIcon} value={RouteEnum.DASHBOARD} />
      {isEmailEnabled && <LeftBarNavigationBar Icon={EmailOutlinedIcon} value={RouteEnum.EMAILS} />}
      {/* <LeftBarNavigationBar*/}
      {/*  badgeCount={unreadCount}*/}
      {/*  Icon={ChatOutlinedIcon}*/}
      {/*  value={RouteEnum.CHATS}*/}
      {/* />*/}
      <LeftBarNavigationBar
        anchorKey={AnnouncementAnchorKey.TASKS_MENU_ITEM}
        Icon={TaskAltIcon}
        value={RouteEnum.TASKS}
      />
      <LeftBarNavigationBar Icon={PointOfSaleOutlinedIcon} value={RouteEnum.PROCESSES} />
      <LeftBarNavigationBar
        anchorKey={AnnouncementAnchorKey.CONTACTS_MENU_ITEM}
        Icon={PermContactCalendarOutlinedIcon}
        value={RouteEnum.CONTACTS}
      />
      <LeftBarNavigationBar
        anchorKey={AnnouncementAnchorKey.CUSTOMERS_INDIVIDUAL_DISTINGUISHING_LABEL}
        Icon={BusinessIcon}
        value={RouteEnum.CUSTOMERS}
      />
      {/* <LeftBarNavigationBar Icon={LocalShippingOutlined} value={RouteEnum.SUPPLIERS} />*/}
      {/* <LeftBarNavigationBar Icon={DirectionsCarFilledOutlinedIcon} value={RouteEnum.CARS} />*/}
      <LeftBarNavigationBar Icon={CalendarMonthOutlinedIcon} value={RouteEnum.RESOURCE_CALENDAR} />
      <LeftBarNavigationBar
        Icon={EventRepeatOutlinedIcon}
        value={RouteEnum.RECURRING_RESERVATIONS}
      />
      <Tab
        disabled
        sx={{
          borderTop: `2px solid ${themeColors.greyLight}`,
          height: 0,
          minHeight: 0,
          p: 0,
        }}
      />
      <LeftBarNavigationBar Icon={MenuBookIcon} value={RouteEnum.DICTIONARIES} />
      {/* <LeftBarNavigationBar*/}
      {/*  Icon={AutoAwesomeMosaicOutlinedIcon}*/}
      {/*  value={RouteEnum.COMPONENT_DEFINITIONS}*/}
      {/* />*/}
      <LeftBarNavigationBar
        Icon={SettingsApplicationsOutlinedIcon}
        value={RouteEnum.OFFER_DEFINITIONS}
      />
      <LeftBarNavigationBar
        Icon={ReportProblemOutlinedIcon}
        value={RouteEnum.FAILED_WORKFLOW_ACTIONS}
      />
      {isCommissionEnabled && (
        <LeftBarNavigationBar Icon={PercentOutlinedIcon} value={RouteEnum.COMMISSIONS} />
      )}
      {isCommissionEnabled && (
        <LeftBarNavigationBar
          Icon={PaymentsOutlinedIcon}
          value={RouteEnum.COMMISSION_ADMINISTRATION}
        />
      )}
      {isCommissionEnabled && (
        <LeftBarNavigationBar Icon={TuneOutlinedIcon} value={RouteEnum.COMMISSION_CONFIGURATION} />
      )}
      {/* <LeftBarNavigationBar*/}
      {/*  Icon={AssessmentOutlinedIcon}*/}
      {/*  value={RouteEnum.REPORTS}*/}
      {/* />*/}
      <LeftBarNavigationBar Icon={PersonOutlinedIcon} value={RouteEnum.USERS} />
      <LeftBarNavigationBar Icon={AdminPanelSettingsOutlinedIcon} value={RouteEnum.ROLES} />
      <LeftBarNavigationBar Icon={PermContactCalendarOutlinedIcon} value={RouteEnum.SUPERVISORS} />
    </Tabs>
  );
};
